export { default } from './InlinePageImageRow';
